import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import { QuickTypes, QuickTypesText } from '../../types/constants';
import { QuickMessageSelectorOptions } from '../../types/types';

import styles from './QuickFields.module.css';
import { MenuChildrenItem } from './MenuFilters/ChildrenItem';
export interface DropMenuTypeSelectorProps {
  id: string;
  value: string;
  onChange: (value: string | null) => void;
  enableOnlyTemplate: boolean;
  enableShowOptionsListAndButtons: boolean;
  enableShowOptionsTemplate: boolean;
}
export function MenuTypeSelector(props: Readonly<DropMenuTypeSelectorProps>) {
  // Traduções
  const filterByTypeText = useGlotaT('spa.chat.quickMessages.filterByType');
  const quickMessageText = useGlotaT('spa.messageBuilder.quickMessages');
  const templateText = useGlotaT('spa.messageBuilder.template');
  const optionsListText = useGlotaT('spa.messageBuilder.optionsList');
  const interactiveButtonsText = useGlotaT('spa.messageBuilder.interactiveButtons');
  
  // Função helper para obter texto traduzido
  const getTranslatedTypeText = (type: string): string => {
    switch (type) {
      case QuickTypes.QUICK:
        return quickMessageText;
      case QuickTypes.TEMPLATE:
        return templateText;
      case QuickTypes.LIST_OPTION:
        return optionsListText;
      case QuickTypes.BUTTONS:
        return interactiveButtonsText;
      default:
        return QuickTypesText[type as keyof typeof QuickTypesText] || type;
    }
  };

  /**
   * Verifica o tipo de opção e informações de canal
   * para definir se a opção está visivel ou não ao usuário
   * return TRUE -> está visivel
   * return FALSE -> está desabilitada
   * @param option
   * @returns
   */
  function canShowOption(option: QuickMessageSelectorOptions) {
    switch (option) {
      case QuickTypes.QUICK:
        // é removido quando é abertura de janela de 24h
        return !props.enableOnlyTemplate;
      case QuickTypes.BUTTONS:
      case QuickTypes.LIST_OPTION:
        // é removido quando é abertura de janela de 24h
        // é removido quando canal não pode realizar envio de template
        if (
          props.enableOnlyTemplate ||
          !props.enableShowOptionsListAndButtons
        ) {
          return false;
        }
        return true;
      case QuickTypes.TEMPLATE:
        // é removido quando canal não pode realizar envio de template
        return !!props.enableShowOptionsTemplate;
      default:
        return false;
    }
  }

  function handleSelect(value: string) {
    props.onChange(value);
  }

  return (
    <div id="quick_type_dropdown">
      <DropdownToggle caret nav>
        {filterByTypeText}
      </DropdownToggle>
      <DropdownMenu className={styles.drop_container}>
        {canShowOption(QuickTypes.QUICK) && (
          <MenuChildrenItem
            active={props.value === QuickTypes.QUICK}
            handleClick={() => handleSelect(QuickTypes.QUICK)}
            text={getTranslatedTypeText(QuickTypes.QUICK)}
          />
        )}

        {canShowOption(QuickTypes.TEMPLATE) && (
          <MenuChildrenItem
            active={props.value === QuickTypes.TEMPLATE}
            handleClick={() => handleSelect(QuickTypes.TEMPLATE)}
            text={getTranslatedTypeText(QuickTypes.TEMPLATE)}
          />
        )}
        {canShowOption(QuickTypes.LIST_OPTION) && (
          <MenuChildrenItem
            active={props.value === QuickTypes.LIST_OPTION}
            handleClick={() => handleSelect(QuickTypes.LIST_OPTION)}
            text={getTranslatedTypeText(QuickTypes.LIST_OPTION)}
          />
        )}
        {canShowOption(QuickTypes.BUTTONS) && (
          <MenuChildrenItem
            active={props.value === QuickTypes.BUTTONS}
            handleClick={() => handleSelect(QuickTypes.BUTTONS)}
            text={getTranslatedTypeText(QuickTypes.BUTTONS)}
          />
        )}
      </DropdownMenu>
    </div>
  );
}
